module.exports = __webpack_public_path__ + "img/nz.9093917a.jpg";